import * as yup from 'yup';
import primarySchema, {
  goldPrimarySchema,
} from './primarySchema';

import type { ValidationError } from 'yup';
import type { Product } from './getTemplate';

export type Logger = (error: Partial<ValidationError>, product?: string) => void;
export type ApplicantData = Record<string, unknown>;

function prepareSchema(product: Product) {
  const productLookup = {
    gold: goldPrimarySchema,
    default: primarySchema,
  };

  // @ts-ignore
  const schema = productLookup[product] ?? productLookup.default;
  return yup.object(schema);
}

async function validateProspect(
  product: Product,
  applicantData: ApplicantData = {},
  logger: Logger = () => { },
) {
  let validationError = {};
  try {
    const schema = prepareSchema(product);
    await schema.validate(applicantData, { abortEarly: true, recursive: true });
  } catch (error) {
    const { errors, message, params } = error as Partial<ValidationError>;
    validationError = { errors, message, params };
    logger(validationError, product);
  }

  return validationError;
}

export default validateProspect;
